import { Quill } from 'vue-quill-editor';
import TextGenerationModule, { withTextGenerationContext } from './module';
import './icons';
import './scss/textGeneration.sass';

Quill.register({
    'modules/textGeneration': TextGenerationModule
}, true);

export { withTextGenerationContext };

export default TextGenerationModule;
